import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

export default class SignUp extends Component {
  constructor(props){
      super(props)
      this.state = {
        name: '',
        email: '',
        password: '',
        user: null,
        errorMessage: '',
        disabled: true,
    }
  }

  handleChange = (event) => {
        let field = event.target.name; //which input
        let value = event.target.value; //what value
        let missing = this.getMissingField()
        if (missing.length > 0){
          this.setState( {[field]: value, disabled: true})
        } else {
          this.setState( {[field]: value, disabled: false})
        }
  }

  getMissingField = () => {
    let allFields = {
      name: this.state.name, 
      email: this.state.email, 
      password: this.state.password, 
    };

    let missing = [];
    Object.keys(allFields).map( (key) => {
      if (allFields[key] === ""){
        missing.push(key);
      }
      return key;
    });
    return missing;
  }

  hasNumber(myString) {
    console.log(/\d/.test(myString))
    return /\d/.test(myString);
  }

  hasSpecial(str){
    return !/[~`!#$%^&*+=\-[\]\\';,/{}|\\":<>?]/g.test(str);
  }

  checkPassword() {
    let problems = {
      length: '8 charactors', 
      number: '1 number', 
      special: '1 special charactor', 
    };
    
    let hasSpecial = this.hasSpecial(this.state.password);
    let hasNum = this.hasNumber(this.state.password);
    let missing = [];
    if (this.state.password.length < 8) {
      missing.push(problems.length);
    }
    if (!hasNum) {
      missing.push(problems.number);
    }
    if (hasSpecial) {
      missing.push(problems.special);
    }
    return missing;
  }

  handleSubmit = (event) => {
    event.preventDefault();
    let missingField = this.getMissingField();
    let checkedPass = this.checkPassword();
    console.log(checkedPass)
    let error = '';

    let fieldStr = 'feild';
    if(missingField.length > 1){
      fieldStr = 'feilds';
    }

    if (missingField.length > 0){
      let missingStr = missingField.toString().replace(/,/g, ', ').replace(/,([^,]*)$/,', and$1');
      error = <p className="alert alert-danger mt-2"><strong>Please fill in the {missingStr} {fieldStr}.</strong></p>;
      this.setState( {fillInError: error, disabled: true} );
    } else if (checkedPass.length > 0){
      let problems = checkedPass.toString().replace(/,/g, ', ').replace(/,([^,]*)$/,', and$1');
      error = <p className="alert alert-danger mt-2"><strong>Password must have {problems}.</strong></p>
      this.setState({fillInError: error});
    } else {
      this.handleSignUp(this.state.email, this.state.password, this.state.name); 
      this.setState({disabled: false, errorMessage: '', fillInError: ''});
      this.props.history.push("/home");
    }

    this.setState({errorMessage: ''})
    
  }

  handleSignUp = (email, password, name) => {
    //console.log(email+password)
    firebase.auth().createUserWithEmailAndPassword(email, password)
      .then((userCredential) => {
        let user = userCredential.user;
        // Trying to add the persons name to their profile
        this.setState({user: user, name: name, signedIn: true});
        this.props.signUpCallback(true, user);
        return userCredential.user.updateProfile({
          displayName: name,
        })
        
      })
      .catch((err) => {
        console.log(err.message)
        let error = <p className="alert alert-danger mt-2"><strong>{err.message}</strong></p>;
        this.setState({errorMessage: error});
      })

      
  }


  render() {
    return (
      <div>
        {this.state.fillInError}
        {this.state.errorMessage}
        <form>
          <label>Name</label>
          <br></br>
          <input onChange={this.handleChange}
          type="name"
          name="name"
          id="name"
          placeholder="name..."
          value={this.state.name}></input>
          <br></br>
          <label>Email</label>
          <br></br>
          <input onChange={this.handleChange}
          type="email"
          name="email"
          id="email"
          placeholder="email..."
          value={this.state.email}></input>
          <br></br>
          <label>Create a Password</label>
          <br></br>
          <input onChange={this.handleChange}
          type="password"
          name="password"
          id="password"
          placeholder="password..."
          value={this.state.password}></input>
          <br></br>
          <button onClick={this.handleSubmit} className="green-button signin-button" aria-label="button" disabled={this.state.disabled} href="/home">Get Started</button>
          <br></br>
        </form>
        <p className="or"><span>or</span></p>
          <StyledFirebaseAuth uiConfig={this.props.uiConfig} firebaseAuth={firebase.auth()}/>
      </div>
    )
  }
}